import type { TokenUsageRow } from '@app/services/api.types';
import { computePct } from './columns';

const CSV_HEADERS = [
    'Branch',
    'Location',
    'Brand',
    'Channel Partner',
    'Admin Email',
    'Admin Phone',
    'Call Tokens',
    'WA Tokens',
    'Total',
    'Monthly Cap',
    '% Used',
];


const escapeCsvCell = (value: string | number): string => {
    const str = String(value ?? '');
    if (/[",\r\n]/.test(str)) {
        return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
};

const buildRow = (branch: string, location: TokenUsageRow): string =>
    [
        branch,
        location.name,
        location.brand_name ?? '',
        location.channel_name ?? '',
        location.contact_email ?? '',
        location.contact_telephone ?? '',
        location.call_tokens_used,
        location.whatsapp_tokens_used,
        location.total_tokens_used,
        location.monthly_token_cap,
        computePct(location),
    ]
        .map(escapeCsvCell)
        .join(',');


export const buildTokenUsageCsv = (rows: TokenUsageRow[]): string => {
    const dataRows = rows.flatMap((row) => {
        const children = row.children ?? [];
        if (children.length) {
            return children.map((child) => buildRow(row.name, child));
        }
        return [buildRow('', row)];
    });

    return [CSV_HEADERS.join(','), ...dataRows].join('\r\n');
};
